import Axios from 'axios';

const state = {
  cakeGoodsList: []
}

const mutations = {
  SET_CAKEGOODS (state, info) {
    state.cakeGoodsList = info
  },
  GET_CAKEGOODS_LIST (state, info) {
    console.log(state.cakeGoodsList)
    return state.cakeGoodsList
  }
}

const actions = {
  async getCakeList () {
    var timestamp = new Date().getTime()
    const res = await Axios.get(
      `/demo/file.js?t=${timestamp}`
    )
    console.log(res.data);
    commit('SET_CAKEGOODS', res.data)
  }
}

export default {
  // namespaced: true,
  state,
  mutations,
  actions
}
